import React from "react";
import "./JoinCommunitySection.css";

const JoinCommunitySection = () => {
  const steps = [
    {
      id: 1,
      icon: "🔍",
      title: "Discover",
      desc: "Search for verified women-led businesses in your area using our smart filters.",
    },
    {
      id: 2,
      icon: "✅",
      title: "Book & Pay Securely",
      desc: "Choose your service, book instantly, and pay with escrow protection.",
    },
    {
      id: 3,
      icon: "⭐",
      title: "Review & Support",
      desc: "Share your experience and help other women entrepreneurs grow.",
    },
  ];

  const benefits = [
    {
      icon: "👩‍💼",
      title: "Reach More Customers",
      desc: "Get discovered by thousands of customers actively searching for your services.",
    },
    {
      icon: "🔒",
      title: "Build Trust with Verification",
      desc: "Stand out with our WC-Verified badge and boost customer confidence.",
    },
    {
      icon: "📈",
      title: "Grow Your Business",
      desc: "Access tools, insights, and support to scale your business faster.",
    },
  ];

  return (
    <div className="wc-join-section">
      {/* Section 1: HOW IT WORKS */}
      <section className="wc-join-howitworks">
        <h2 className="wc-join-title">How It Works</h2>
        <p className="wc-join-subtitle">Get started in three simple steps</p>
        <div className="wc-join-steps">
          {steps.map((step) => (
            <div key={step.id} className="wc-join-step-card">
              <div className="wc-join-step-icon">
                {step.icon}
                <span className="wc-join-badge">{step.id}</span>
              </div>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Section 2: FOR WOMEN ENTREPRENEURS */}
      <section className="wc-join-entrepreneurs">
        <h2 className="wc-join-title">For Women Entrepreneurs</h2>
        <p className="wc-join-subtitle">
          Join thousands of successful women-led businesses on our platform
        </p>
        <div className="wc-join-benefits">
          {benefits.map((item, index) => (
            <div key={index} className="wc-join-benefit-card">
              <div className="wc-join-benefit-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Section 3: READY TO GROW YOUR BUSINESS */}
      <div className="wc-join-callout-container">

      <div className="wc-join-callout">
        <h2 className="wc-join-callout-title">Ready to Grow Your Business?</h2>
        <p className="wc-join-callout-desc">
          Join our verified marketplace and connect with customers who value your work
        </p>
        <div className="wc-join-actions">
          <button className="wc-join-btn primary">List Your Business Free</button>
          <button className="wc-join-btn secondary">Learn More</button>
        </div>
      </div>
       </div>
      {/* FOOTER */}
     <footer className="wc-footer">
  <div className="wc-footer-container">
    <div className="wc-footer-column">
      <h3 className="wc-footer-title">Women Connect</h3>
      <p className="wc-footer-desc">
        Empowering women entrepreneurs and connecting them with customers who care.
      </p>
    </div>

    <div className="wc-footer-column">
      <h4 className="wc-footer-subtitle">For Customers</h4>
      <ul>
        <li>Browse Services</li>
        <li>How it Works</li>
        <li>Trust & Safety</li>
        <li>Help Center</li>
      </ul>
    </div>

    <div className="wc-footer-column">
      <h4 className="wc-footer-subtitle">For Businesses</h4>
      <ul>
        <li>List Your Business</li>
        <li>Pricing</li>
        <li>Get Verified</li>
        <li>Success Stories</li>
      </ul>
    </div>

    <div className="wc-footer-column">
      <h4 className="wc-footer-subtitle">Stay Updated</h4>
      <p className="wc-footer-desc">Get the latest updates and offers</p>
      <div className="wc-footer-subscribe">
        <input type="email" placeholder="Your email" />
        <button>Subscribe</button>
      </div>
    </div>
  </div>

  <hr className="wc-footer-divider" />

  <div className="wc-footer-bottom">
    © 2025 Women Connect. All rights reserved.
  </div>
</footer>

    </div>
  );
};

export default JoinCommunitySection;
